/**
 * Вкус в localStorage — рядом с историей прослушиваний и по тем же правилам:
 * ничего никуда не отправляется, всё живёт в браузере.
 *
 * Хранится отдельно от событий, потому что это свёртка, а не журнал: она
 * маленькая (до 64 тегов) и читается на каждом подборе, а перебирать ради неё
 * четыреста событий незачем.
 */
import { EMPTY_TASTE, type Taste } from "../core/taste";

const KEY = "pw.taste";

let memory: Taste | null = null;

export function loadTaste(): Taste {
  if (memory) return memory;
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    memory = parsed && typeof parsed.at === "number" && parsed.tags && typeof parsed.tags === "object"
      ? { at: parsed.at, tags: parsed.tags as Record<string, number> }
      : EMPTY_TASTE;
  } catch {
    memory = EMPTY_TASTE;   // приватный режим или испорченная запись
  }
  return memory;
}

export function saveTaste(taste: Taste) {
  memory = taste;
  try { localStorage.setItem(KEY, JSON.stringify(taste)); }
  catch { /* квота или приватный режим — вкус живёт до конца вкладки */ }
}
